import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import logo from "../../assets/digitalparag/DigirtalParag.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from "../../helpers/apiHelpers";
import loginImage from "../../assets/login.jpg";

const Sign_up = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    officename: "",
    email: "",
    mobile: "",
    password: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (
        !formData.fullname ||
        !formData.email ||
        !formData.mobile ||
        !formData.officename ||
        !formData.password
      ) {
        toast.error("Enter all Fields");
      } else {
        const response = await axios.post(
          `${api_url}/api/auth/signup`,
          formData
        );
        if (response.data.status === 201) {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate("/sign_in");
          }, 2000); // Redirect after 2 seconds
        } else {
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      toast.error("Signup failed. Please try again.");
    }
  };

  return (
    <div>
      <Header />
      <br />
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-2xl lg:max-w-4xl">
        <div
          className="hidden bg-cover lg:block lg:w-1/2"
          style={{
            backgroundImage: `url(${loginImage})`,
          }}
        ></div>

        <div
          className="text-left w-full px-6 py-3 md:px-8 lg:w-1/2"
          style={{ backgroundColor: "#a3c8e8" }}
        >
          <div className="flex justify-center mx-auto">
            <img className="h-20 w-30 mr-3" src={logo} alt="Logo" />
          </div>

          <h3 className="mt-1 fw-bold text-2xl text-center text-dark ">
            Create your account!
          </h3>

          <form onSubmit={handleSubmit}>
            <div className="mt-2">
              <label
                className="block mb-2 text-base font-medium text-dark  "
                htmlFor="fullname"
              >
                Full Name
              </label>
              <input
                id="fullname"
                name="fullname"
                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="text"
                value={formData.fullname}
                onChange={handleChange}
              />
            </div>

            <div className="mt-2">
              <label
                className="block mb-2 text-base font-medium text-dark "
                htmlFor="officename"
              >
                Office Name
              </label>
              <input
                id="officename"
                name="officename"
                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="text"
                value={formData.officename}
                onChange={handleChange}
              />
            </div>

            <div className="mt-2">
              <label
                className="block mb-2 text-base font-medium text-dark  "
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="mt-2">
              <label
                className="block mb-2 text-base font-medium text-dark "
                htmlFor="mobile"
              >
                Mobile No.
              </label>
              <input
                id="mobile"
                name="mobile"
                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="text"
                value={formData.mobile}
                onChange={handleChange}
              />
            </div>

            <div className="mt-2">
              <label
                className="block mb-2 text-base font-medium text-dark "
                htmlFor="password"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="password"
                value={formData.password}
                onChange={handleChange}
              />
            </div>

            <div className="mt-3 text-center">
              <button
                type="submit"
                className="w-1/2 px-6 py-2 text-base font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
              >
                Sign Up
              </button>
            </div>
          </form>

          <div className="flex items-center justify-between mt-4">
            <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>
            <Link
              to="/sign_in"
              className="text-base text-dark fw-bold uppercase dark:text-gray-400 hover:underline"
            >
              or login
            </Link>
            <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>
          </div>
        </div>
      </div>
      <br /> <br />
      <br />
      <Footer />
      <ToastContainer />
    </div>
  );
};

export default Sign_up;
